import Vue from 'vue';

import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);

import 'primevue/resources/themes/saga-blue/theme.css';		//theme
import 'primevue/resources/primevue.min.css';							//core css
import 'primeicons/primeicons.css';												//icons
import 'primeflex/primeflex.css';

/* ВСПЛЫВАЮЩИЕ СООБЩЕНИЯ */
/*
	компонент p-toast для работоспособности
	добавлен в html один раз (в корневой компонент App)
*/
import ToastService from 'primevue/toastservice';
import PToast from 'primevue/toast';
Vue.use(ToastService);
Vue.component('PToast', PToast); 

import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
Vue.use(ConfirmationService);
Vue.component('PConfirm', ConfirmDialog);

/* Тултипы (всплывающие подсказки) */
import PTooltip from 'primevue/tooltip';
Vue.directive('tooltip', PTooltip);


/* ИСПОЛЬЗУЕМЫЕ КОМПОНЕНТЫ */
import PBlockUi from 'primevue/blockui';
import PButton from 'primevue/button';
import pCalendar from 'primevue/calendar';
import PCheckbox from 'primevue/checkbox';
import PDialog from 'primevue/dialog';
import PDivider from 'primevue/divider';
import PDropdown from 'primevue/dropdown';
import PFileUpload from 'primevue/fileupload';
import PGalleria from 'primevue/galleria';
import PInputText from 'primevue/inputtext';
import PInputNumber from 'primevue/inputnumber';
import PMessage from 'primevue/message';
import PMultiselect from 'primevue/multiselect';
import POverlayPanel from 'primevue/overlaypanel';
import PPaginator from 'primevue/paginator';
import PPanel from 'primevue/panel';
import PPassword from 'primevue/password';
import PSpinner from 'primevue/progressspinner';
import PSplitButton from 'primevue/splitbutton';
import PTabmenu from 'primevue/tabmenu';
import PTabview from 'primevue/tabview';
import PToolbar from 'primevue/toolbar';
import PTable from 'primevue/datatable';
import PColumn from 'primevue/column';
import PTextarea from 'primevue/textarea';

Vue.component('PBlockUi', PBlockUi);
Vue.component('PButton', PButton);
Vue.component('pCalendar', pCalendar);
Vue.component('PCheckbox', PCheckbox);
Vue.component('PDialog', PDialog);
Vue.component('PDivider', PDivider);
Vue.component('PDropdown', PDropdown);
Vue.component('PFileUpload', PFileUpload);
Vue.component('PGalleria', PGalleria);
Vue.component('PInputText', PInputText);
Vue.component('PInputNumber', PInputNumber);
Vue.component('PMessage', PMessage);
Vue.component('PMultiselect', PMultiselect);
Vue.component('POverlayPanel', POverlayPanel);
Vue.component('PPaginator', PPaginator);
Vue.component('PPanel', PPanel);
Vue.component('PPassword', PPassword);
Vue.component('PSpinner', PSpinner);
Vue.component('PSplitButton', PSplitButton);
Vue.component('PTabmenu', PTabmenu);
Vue.component('PTabview', PTabview);
Vue.component('PToolbar', PToolbar);
Vue.component('PTable', PTable);
Vue.component('PColumn', PColumn);
Vue.component('PTextarea', PTextarea);